import { Button } from '../catalyst/button';

/**
 * DR-2426: shared "Show more (N of M remaining)" control for locally-windowed lists
 * (DocumentPages, DocumentReconstructionPreview). Built on the Catalyst `Button` plain
 * variant per the primitives rule.
 */
export function ShowMoreButton({
  remaining,
  total,
  onClick,
  loading = false,
}: {
  /** Items still hidden below the current window. */
  remaining: number;
  /** Total items in the (filtered) list. */
  total: number;
  onClick: () => void;
  /** Keeps the control stable while a cursor/window request is in flight. */
  loading?: boolean;
}) {
  return (
    <div className="p-3 text-center">
      <Button plain onClick={onClick} disabled={loading}>
        {loading ? 'Loading more…' : `Show more (${remaining} of ${total} remaining)`}
      </Button>
    </div>
  );
}
